import React, { useState } from "react";

export default function Portfolio({ gallery }) {
    const [active, setActive] = useState(null);
    if (!gallery || gallery.length === 0) return null;

    return (
        <section id="portfolio" className="relative bg-black border-t border-zinc-900">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
                <div className="grid md:grid-cols-12 gap-10 items-end mb-16">
                    <div className="md:col-span-7">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-yellow-400" />
                            <span className="font-mono-accent text-[11px] text-yellow-400">
                                02 / Recent work
                            </span>
                        </div>
                        <h2
                            data-testid="portfolio-heading"
                            className="font-display text-white text-5xl md:text-7xl lg:text-8xl"
                        >
                            Slabs that <span className="text-yellow-400">speak</span> for themselves.
                        </h2>
                    </div>
                    <div className="md:col-span-5 text-zinc-400 text-base md:text-lg leading-relaxed">
                        Real projects. Real customers. All photos taken by our crew, right here in
                        Colorado.
                    </div>
                </div>

                {/* Asymmetric mosaic */}
                <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
                    {gallery.map((g, i) => {
                        const patterns = [
                            "md:col-span-4 md:row-span-2 aspect-[4/3] md:aspect-auto md:h-[560px]",
                            "md:col-span-2 aspect-square",
                            "md:col-span-2 aspect-square",
                            "md:col-span-3 aspect-[4/3]",
                            "md:col-span-3 aspect-[4/3]",
                            "md:col-span-6 aspect-[16/9]",
                        ];
                        const cls = patterns[i % patterns.length];
                        return (
                            <button
                                key={g.id || i}
                                onClick={() => setActive(g)}
                                data-testid={`gallery-item-${i}`}
                                className={`${cls} group relative overflow-hidden bg-zinc-900 border border-zinc-900 hover:border-yellow-400 transition-colors`}
                            >
                                <img
                                    src={g.image_url}
                                    alt={g.title}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
                                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 text-left">
                                    <div className="font-mono-accent text-[10px] text-yellow-400 mb-1">
                                        {g.category}
                                    </div>
                                    <div className="font-display text-white text-2xl md:text-3xl">
                                        {g.title}
                                    </div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>

            {/* Lightbox */}
            {active && (
                <div
                    className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 md:p-10"
                    onClick={() => setActive(null)}
                    data-testid="gallery-lightbox"
                >
                    <button
                        onClick={() => setActive(null)}
                        className="absolute top-6 right-6 font-mono-accent text-xs text-white hover:text-yellow-400"
                    >
                        [ CLOSE ]
                    </button>
                    <div className="max-w-6xl max-h-[85vh] relative">
                        <img
                            src={active.image_url}
                            alt={active.title}
                            className="max-w-full max-h-[85vh] object-contain"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-black/80 p-4">
                            <div className="font-mono-accent text-[10px] text-yellow-400">
                                {active.category}
                            </div>
                            <div className="font-display text-white text-2xl">
                                {active.title}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
